import { BankTransferIcon, GiftCardIcon, OriginalPaymentMethodIcon, StoreCreditIcon } from '@reveni-io/reveni-ui'

export const extraFeeTypes = {
  fixedAmount: 'fixed_amount',
  percentage: 'percentage',
  deliveryMethodFee: 'delivery_method_fee',
}

export const refundMethods = {
  bank_transfer: {
    name: 'Transferencia instantánea',
    icon: <BankTransferIcon />,
  },
  store_credit: {
    name: 'Crédito en tienda',
    icon: <StoreCreditIcon />,
  },
  original_payment_method: {
    name: 'Método de pago original',
    icon: <OriginalPaymentMethodIcon />,
  },
  gift_card: {
    name: 'Tarjeta regalo',
    icon: <GiftCardIcon />,
  },
}

export const contentAnimation = {
  collapsed: { height: 0, opacity: 0, overflow: 'hidden' },
  expanded: { height: 'auto', opacity: 1, transitionEnd: { overflow: 'visible' } },
  duration: 0.25,
}
